export default __webpack_public_path__ + "static/moneybus_small-1-3ec9f5402bb9bf67c89153be335a2cb5.webp";